import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SubMenu from './sub-menu';


export default class LinksSection extends Component {
  constructor(props) {
    super(props);
    const { selected } = this.props;
    this.state = {
      selected,
    };
  }

  handleChange(selected) {
    this.setState({ selected });
  }

  render() {
    const { menu } = this.props;
    const { selected } = this.state;
    const titles = [];
    let links = [];
    const pages = menu.map((section, i) => {
      if (section.data.length) {
        titles.push({ name: section.title, visible: true });
        links = section.data.map((link, a) => (
          <li key={ `landing-page__links-section__list-pages__page__content__item-${a}` } className="landing-page__links-section__list-pages__page__content__item">
            <a className="landing-page__links-section__list-pages__page__content__item__link" href={ `${link.url}/` }>
              { link.title }
            </a>
          </li>
        ));
        return (
          <li key={ `landing-page__links-section__list-pages__page-${i}` } className={ `landing-page__links-section__list-pages__page ${selected === section.title ? '-is-selected' : ''}` }>
            <ul className="landing-page__links-section__list-pages__page__content" style={ { width: (links.length / 4) * 230 + 100 } }>
              { links }
            </ul>
          </li>
        );
      }
      return null;
    });

    return (
      titles.length
        ? (
          <section className="landing-page__links-section">
            <SubMenu
              className="landing-page__links-section__tabs"
              handleChange={ this.handleChange.bind(this) }
              items={ titles }
              selected={ titles[0].name }
            />
            <ul className="landing-page__links-section__list-pages">
              { pages }
            </ul>
          </section>
        )
        : null
    );
  }
}

LinksSection.defaultProps = {
  selected: '',
};

LinksSection.propTypes = {
  menu: PropTypes.arrayOf(
    PropTypes.shape({
      data: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          url: PropTypes.string,
        })
      ),
      title: PropTypes.string,
    })
  ).isRequired,
  selected: PropTypes.string,
};
